var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRoundedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#DD4630"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0478 11.0729C17.1641 11.0729 17.2696 11.1236 17.353 11.2094C17.4307 11.3009 17.4699 11.4147 17.4585 11.5349C17.4585 11.5745 17.1476 15.5061 16.9701 17.161C16.8589 18.1766 16.2042 18.7932 15.2221 18.8101C14.467 18.827 13.729 18.8329 13.0022 18.8329C12.2307 18.8329 11.4761 18.827 10.7437 18.8101C9.79457 18.7874 9.13932 18.1597 9.03379 17.161C8.85112 15.5003 8.5459 11.5745 8.54022 11.5349C8.53455 11.4147 8.57313 11.3009 8.65142 11.2094C8.72857 11.1236 8.83977 11.0729 8.95664 11.0729H17.0478ZM14.2044 7.1662C14.7201 7.1662 15.1808 7.52611 15.3141 8.03944L15.4094 8.46527C15.4866 8.81235 15.7873 9.05793 16.1333 9.05793H17.8342C18.0611 9.05793 18.25 9.24634 18.25 9.48609V9.70776C18.25 9.94167 18.0611 10.1359 17.8342 10.1359H8.16641C7.93892 10.1359 7.75 9.94167 7.75 9.70776V9.48609C7.75 9.24634 7.93892 9.05793 8.16641 9.05793H9.86725C10.2127 9.05793 10.5134 8.81235 10.5911 8.46585L10.6802 8.06802C10.8186 7.52611 11.2742 7.1662 11.7956 7.1662H14.2044Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRoundedIcon);
export default __webpack_public_path__ + "static/media/delete-rounded-icon.a727550825b643a62f257477fd3cf4f5.svg";
export { ForwardRef as ReactComponent };